module.exports = {"130271100":"芦台开发区海北镇","130271450":"芦台开发区新华路街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130271.json
// module id = 93
// module chunks = 0